import { apply, curry } from 'ramda';
import LocalStorage from '../services/webStorage/LocalStorage';

type func = () => void;
export const isFunction = <T extends func>(value: any): value is T => typeof value === 'function';

export const setLabelDisplay = (value: boolean) => {
	LocalStorage.set('entity_label_display', value);
};

export const getLabelDisplay = () => {
	return LocalStorage.get('entity_label_display');
};

export const isDevView = () => {
	return LocalStorage.get('customer_not_view');
};

const turnOnDevView = () => {
	LocalStorage.set('customer_not_view', true);
};

const turnOffDevView = () => {
	LocalStorage.remove('customer_not_view');
};

const devViewListener = (e: any) => {
	// [ key for dev view
	if (e.keyCode === 219 && e.ctrlKey && e.shiftKey) {
		e.preventDefault();
		turnOnDevView();
		location.reload();
	}

	// ] key for customer view
	if (e.keyCode === 221 && e.ctrlKey && e.shiftKey) {
		e.preventDefault();
		turnOffDevView();
		location.reload();
	}
};

export const addDevViewEventListeners = () => {
	typeof document !== 'undefined' && document.addEventListener('keydown', devViewListener);
};

export const debounce = curry((immediate: boolean, timeMs: number, fn: () => any) => {
	let timeout: any;

	return (...args: any[]) => {
		const later = () => {
			timeout = null;

			if (!immediate) {
				apply(fn, args);
			}
		};

		const callNow = immediate && !timeout;

		clearTimeout(timeout);
		timeout = setTimeout(later, timeMs);

		if (callNow) {
			apply(fn, args);
		}

		return timeout;
	};
});

// Copies content to clipboard
export const copyToClipboard = (innerText?: string | null, cb?: () => void) => {
	if (innerText) {
		const valueElement = document.createElement('textarea');
		valueElement.innerHTML = innerText;
		document.body.appendChild(valueElement);
		valueElement.select();
		document.execCommand('copy');
		valueElement.remove();

		cb && cb();
	}
};

export const scrollToTop = (top?: number) => {
	window.scrollTo({
		top: typeof top === 'number' ? top : 87,
		behavior: 'auto',
	});
};
